import store from '~/store'
import swal from 'sweetalert2'
import i18n from '~/plugins/i18n'

export default (to, from, next) => {
  if (store.getters['auth/user'].role < 4) {
    /*swal({
      type: 'error',
      title: i18n.t('wrong_place_header'),
      text: i18n.t('wrong_place_text'),
      reverseButtons: true,
      confirmButtonText: i18n.t('ok'),
      cancelButtonText: i18n.t('cancel')
    });*/
    next({ name: 'home' });
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/admin.js